<template>
  <section>
    <b-modal size="lg" id="invoice-charge-modal" ref="invoice-charge-modal" title="Invoice Charges" 
      centered no-close-on-backdrop>
        <b-row>
          <b-col>
            <h6>The following charges are defined on the sales order. Add necessary charges to the invoice.</h6>
          </b-col>
        </b-row>
        <grid-component
            :gridId="salesOrderGridId"
            :itemData="soChargesData"
            :fields="soFields"
            :handleRowClick="onSalesOrderChargeClick"
          />
        <b-row>
          <b-col sm="2">
            <label for="input-small"></label>
          </b-col>
          <b-col sm="8" class="pl-0">
            <!-- <b-form-group label-cols="2">
              <b-form-radio v-model="chargesObj.isNoCharge" name="isInHouse" :value="false" inline>Customer Charge</b-form-radio>
              <b-form-radio v-model="chargesObj.isNoCharge" name="isInHouse" :value="true" inline>In-House Expense</b-form-radio>
            </b-form-group> -->
            <b-form-group label="Type" label-align="right" label-cols="2">
              <b-form-select @change="checkOkSubmit" v-model="chargesObj.expenseAccountId">
                <option
                  v-for="chargeType in sortSelect(chargesTypes,'accountName')"
                  :key="chargeType.id" :value="chargeType.id">{{chargeType.accountName}}</option>
              </b-form-select>  
            </b-form-group>
            <b-form-group label="Description" label-align="right" label-cols="2">
              <b-form-input v-model="chargesObj.description" @input="checkOkSubmit"></b-form-input>
            </b-form-group>            
            <b-form-group label-cols="2" label-align="right" label="Amount">
              <b-form-input type="number" v-model="chargesObj.amount" @input="checkOkSubmit"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <template slot="modal-footer">
          <b-button
            v-if="isEdit"
            size="sm"
            variant="danger"
            @click="deleteCharge"
          >
            Delete
          </b-button>
          <b-button
            size="sm"
            variant="secondary"
            @click="closeChargesModal"
          >
            Cancel
          </b-button>
          <b-button
            :disabled="okButtonDisabled"
            size="sm"
            variant="primary"
            @click="submitCharge(false)"
          >
            Save & New
          </b-button>
          <b-button
            :disabled="okButtonDisabled"
            size="sm"
            variant="primary"
            @click="submitCharge(true)"
          >
            Save & Close
          </b-button>
      </template>
    </b-modal>
    <div class="d-flex justify-content-end mb-3">
      <b-button @click="openChargesModal" size="sm" variant="primary">
        <i class="fa fa-plus" aria-hidden="true"></i>
        Add New
      </b-button>
    </div>
    <grid-component
      isResizable
      isReorderable
      isSortable
      :gridId="gridId"
      :itemData="charges"
      :fields="fields"
      :onEdit="editChargesModal"
      :onDelete="deleteChargeGrid"
     />
  </section>

</template>


<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { GRID_ID } from '@/shared/constants';
import {chargesListFields} from './fields';
import salesOrderChargesFields from './fields';
import GridComponent from '@/shared/components/GridComponent';

export default {
  components: {
    GridComponent
  },
  props: {
    invoiceId: {
      type: [Number, String],
      default: 0
    },
    salesOrderId: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      fields: chargesListFields,
      soFields: salesOrderChargesFields,
      chargesObj: {
        id: 0,
        salesOrderChargeId: 0,
        expenseAccountId: '',
        description: '',
        amount: '',
        isNoCharge: false,
        isTaxable: false,
        active: true,
      },
      isEdit: false,
      okButtonDisabled: true,
      expenseAccts: 7,
      incomeAccts: 9,
      gridId: '',
      salesOrderGridId: GRID_ID.SALES_ORDERS_TO_INVOICES_CHARGE_GRID
    }
  },
  computed: {
    ...mapState('invoices', {
      // invoiceChargesTypes: 'chargesTypes',
      invoiceCharges: 'charges',
      salesOrderCharges: 'salesOrderCharges'
    }),
    ...mapState('chargesList', ['expenseAndIncomeAccounts']),
    chargesTypes() {
      // return (this.chargesObj.isNoCharge)
      // ? this.expenseAndIncomeAccounts.filter(x => x.accountTypeId == this.expenseAccts).sort((a, b) => (a.accountName > b.accountName) ? 1 : -1)
      // : this.expenseAndIncomeAccounts.filter(x => x.accountTypeId == this.incomeAccts).sort((a, b) => (a.accountName > b.accountName) ? 1 : -1);
      return this.expenseAndIncomeAccounts.filter(x => x.accountTypeId == this.incomeAccts).sort((a, b) => (a.accountName > b.accountName) ? 1 : -1);
    },
    charges() {
      if (this.invoiceId) {
        return this.invoiceCharges;
      }
    },
    soChargesData() {
      return this.salesOrderCharges.map((soCharge) => ({ ...soCharge, selected: soCharge.id === this.chargesObj.salesOrderChargeId }));
    }
  },
  methods: {
    ...mapActions('invoices', {
      getInvoicesChargesTypes: 'getChargesTypes',
      getInvoicesChargesById: 'getChargesById',
      addNewInvoicesCharge: 'addNewCharge',
      deleteInvoicesChargeById: 'deleteChargeById',
      editInvoicesChargeById: 'editChargeById',
      getSalesOrderCharges: 'getSalesOrderCharges'
    }),
    ...mapActions('chargesList', ['getExpenseAndIncomeCharges']),
       // @todo: Add CRUD logic
    handleAdd() {},
    handleEdit() {},
    handleDelete() {},
    checkOkSubmit() {
      //If type and description is not empty
      if(this.chargesObj.expenseAccountId && this.chargesObj.amount) {
        this.okButtonDisabled = false;
      } else {
        this.okButtonDisabled = true;
      }
    },
  	openChargesModal() {
      this.$refs['invoice-charge-modal'].show();
    },
    closeChargesModal() {
      this.chargesModalReset();
      this.$refs['invoice-charge-modal'].hide();
    },
    onSalesOrderChargeClick({ dataItem }) {
      this.chargesObj = {
        ...this.chargesObj,
        salesOrderChargeId: dataItem.id,
        isNoCharge: dataItem.isNoCharge,
        amount: dataItem.remaining || 0
      }
    },
    editChargesModal(props) {
      this.isEdit = true;

      this.chargesObj = { ...props };

      this.okButtonDisabled = false;

      this.openChargesModal();
    },
    async submitCharge(isClose) {
      this.okButtonDisabled = true;
      if (isClose) {
          this.$refs['invoice-charge-modal'].hide();  
      }
      if(this.isEdit) {
        const editCharge = await this.editCharge();
        //this.$emit('updateTotal',editCharge.quoteSummary);
      } else {
        const newCharge = await this.addNewCharge();
        //this.$emit('updateTotal',newCharge.quoteSummary);
      }
      this.okButtonDisabled = false;
      if (!isClose) {
        this.chargesModalReset();
      }

      this.chargesList();
      this.$emit('updateCharge');  
    },
    async deleteChargeGrid(props) {
      //If clicked on icon directly, so object needs to be set

      this.chargesObj.isNoCharge = this.chargesObj.noCharge ? true : false;

      this.chargesObj = { ...props };

      await this.deleteCharge();

    },
    async deleteCharge() {
      const deleteConfirmed = await this.openConfirmBox({message: 'Are you sure you want to delete charge?'});
      if (deleteConfirmed) {
        const quoteSummary = await this.deleteChargeById();
        //this.$emit('updateTotal',quoteSummary);
        this.$refs['invoice-charge-modal'].hide();
        await this.chargesList();
        this.$emit('updateCharge');
      }
      this.chargesObj = {};
    },
    async addNewCharge() {
      if (this.invoiceId) {
        await this.addNewInvoicesCharge(this.chargesObj);
      }
    },
    async deleteChargeById() {
      if(this.invoiceId) {
        await this.deleteInvoicesChargeById(this.chargesObj)
      }
    },
    async editCharge() {
      if(this.invoiceId) {
        return await this.editInvoicesChargeById(this.chargesObj);
      }
    },
    async chargesList() {
      if(this.invoiceId) {
        this.gridId = GRID_ID.INVOICE_CHARGES_GRID;
        await this.getInvoicesChargesById(this.invoiceId);
      }
    },
    chargesModalReset() {
      this.chargesObj = {
        id: 0,
        salesOrderChargeId: 0,
        expenseAccountId: '',
        description: '',
        amount: '',
        isNoCharge: false,
        isTaxable: false,
        active: true,
      };
      
      if (this.invoiceId) {
        this.chargesObj = { ...this.chargesObj, invoiceId: this.invoiceId };
      }

      this.isEdit = false;

      this.okButtonDisabled = true;
    },
  },
  async mounted() {
    if (this.invoiceId) {
      this.chargesObj = { ...this.chargesObj, invoiceId: this.invoiceId, };
      this.gridId = GRID_ID.INVOICE_CHARGES_GRID;
      
      if (this.salesOrderId) {
        this.getSalesOrderCharges(this.salesOrderId);
      }
    }
    await this.chargesList();
    await this.getExpenseAndIncomeCharges();
  },
};
</script>
